import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { NavLink } from 'reactstrap';

import { currentUserData } from '../../features/fe-data/selectors';
import './DeveloperLegacyNavbar.css';

export const DeveloperLegacyNavbarComponent = ({ currentUser }) => (
  <div className="pdx-developer-navbar legacy-navbar apply-design-system">
    <nav className="navbar navbar-expand navbar-dark">
      <a href="/developer/apps" className="navbar-brand">Pagerduty</a>
      <div className="developer-badge">Developer</div>
      <ul className="mr-auto navbar-nav">
        <li className="nav-item">
          <a href="https://developer.pagerduty.com/docs/get-started/getting-started/" className="nav-link" target="_blank" rel="noopener noreferrer">Documentation</a>
        </li>

        <li className="nav-item">
          <a href="https://developer.pagerduty.com/api-reference" className="nav-link" target="_blank" rel="noopener noreferrer">REST API Reference</a>
        </li>

        <li className="nav-item">
          <NavLink href="/developer/apps" className="nav-my-apps-link nav-link">My Apps</NavLink>
        </li>
      </ul>

      <ul className="navbar-nav">
        <li className="nav-item">
          <a href={window.location.origin} className="nav-return nav-link">Return to PagerDuty Account</a>
          <img src={currentUser.avatarUrl} size="30" width="30" height="30" alt={currentUser.name} title={currentUser.name} />
        </li>
      </ul>
    </nav>
  </div>
);

const mapStateToProps = state => ({
  currentUser: currentUserData(state)
});

DeveloperLegacyNavbarComponent.propTypes = {
  currentUser: PropTypes.shape({
    avatarUrl: PropTypes.string,
    name: PropTypes.string,
  }).isRequired
};
export default connect(mapStateToProps)(DeveloperLegacyNavbarComponent);
